/**
 * Reads `<meta name="base_url" content="...">` from public/index.html (must match deploy path).
 * @returns {string} '' for root (`/` or empty), otherwise a path prefix without trailing slash, e.g. '/100'
 */
function normalizeBaseUrlMeta(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  let s = raw.trim();
  if (!s || s === '/') return '';
  if (!s.startsWith('/')) s = `/${s}`;
  return s.replace(/\/+$/, '');
}

export function getBasePath() {
  if (typeof document === 'undefined') return '';
  const meta = document.querySelector('meta[name="base_url"]');
  const raw = meta?.getAttribute('content');
  return normalizeBaseUrlMeta(raw);
}

/**
 * Full login path for redirects (respects web folder).
 * @returns {string} e.g. '/login' or '/100/login'
 */
export function getLoginPath() {
  const base = getBasePath();
  return base ? `${base}/login` : '/login';
}

/**
 * Prefix an app-relative path with the web-folder base (e.g. /100) when deployed under a subpath.
 * Use for imperative navigation: window.open, location.assign, anchor href strings — anything that
 * does not go through React Router's basename.
 *
 * @param {string} path - Path beginning with /, e.g. '/crf/template/1?preview=1'
 * @returns {string} e.g. '/crf/...' at root, or '/100/crf/...' when hosted under /100/
 */
export function withBasePath(path) {
  const base = getBasePath();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}
